<template>
    <div class="page">
        <box>
            <el-form v-if="packUpIsShow" label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道编号" class="EL-Form-Item">
                        <el-select v-model="orderSearch.query.whCode" placeholder="请选择" clearable="clearable">
                            <el-option v-for="item in warehouseList" :key="item.whId" :label="item.whCode + '-' + item.whName" :value="item.whCode">{{item.whCode}}-{{item.whName}}</el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="订单号" class="EL-Form-Item">
                        <el-input v-model="orderSearch.query.orderCode" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="orderSearch.query.matCode" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="收货类型" class="EL-Form-Item">
                        <el-select v-model="orderSearch.query.saleFlag" placeholder="请选择" clearable="clearable">
                            <!-- <el-option  key="10" label="非寄售" value="10" /> -->
                            <el-option label="寄售" :value="true"></el-option>
                            <el-option label="非寄售" :value="false"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getOrderList()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="orderReset()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="采购员" class="EL-Form-Item">
                        <el-input v-model="orderSearch.query.buyer" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="供应商" class="EL-Form-Item">
                        <el-input v-model="orderSearch.query.supply" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="订单状态" class="EL-Form-Item">
                        <el-select v-model="orderSearch.query.orderStatus" placeholder="请选择" clearable="clearable">
                            <el-option label="进行中" value="EXECUTE" />
                            <el-option label="完成" value="COMPLETE" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="6" :xl="5">
                    <el-form-item label="要求到货开始时间" class="EL-Form-Item" label-width="130px">
                        <el-date-picker v-model="orderSearch.query.beginTime" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="6" :xl="5">
                    <el-form-item label="要求到货结束时间" class="EL-Form-Item" label-width="130px">
                        <el-date-picker v-model="orderSearch.query.endTime" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form>
            <plabel text="订单详情">
                <el-button v-authority="'BACK_MENU3_M24_B1'" class="btn-t-edit" @click="deliveryInConsignment()">
                    寄售收货
                </el-button>
                <el-button v-authority="'BACK_MENU3_M24_B3'" class="btn-t-edit" @click="isReceivingDetails = true">
                    订单同步
                </el-button>
                 <!-- <el-button v-authority="'BACK_MENU3_M1_B3'" class="btn-t-edit" @click="deliveryIn()">
                    非寄售收货
                </el-button> -->
                <!-- <el-button v-authority="'XCMENUCODE'" class="btn-t-edit" @click="ReceivingDetail()">
                    数量修改
                </el-button> -->
                <el-button :loading="downloadLoading" class="btn-t-edit export" type="primary" v-authority="'BACK_MENU3_M24_B4'" @click="downLoadFile()">
                    导出EXCEL
                </el-button>
            </plabel>
            <h-table class="IncomingMaterialReceipt-table" :data="orderSearch.data" :headerCellStyle="orderSearch.headerCellStyle" :row-class-name="tableRowClassName" :style="$popups.harvestRecordStyle(0.73)" @pageChange="getOrderList" pagination :nowPage.sync="orderSearch.pageNum" :pageSize.sync="orderSearch.pageSize" :total.sync="orderSearch.total" @selectionChange="selectAllOrder">
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column label="收货类型" prop="saleFlag" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.saleFlag == false">非寄售</span>
                        <span v-else-if="scope.row.saleFlag == true">寄售</span>
                    </template>
                </el-table-column>
                <el-table-column label="通道编号" prop="whCode" align="center">
                </el-table-column>
                <el-table-column label="订单号" prop="orderCode" align="center">
                </el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center">
                </el-table-column>
                <el-table-column label="物料描述" prop="matName" align="center">
                </el-table-column>
                <el-table-column label="订单数量" prop="orderQuan" align="center">
                </el-table-column>
                <el-table-column label="已收数量" prop="orderArriveQuan" align="center">
                </el-table-column>
                <el-table-column label="退货数量" prop="orderReturnQuan" align="center">
                </el-table-column>
                <el-table-column label="未收数量" prop="notReceivedNumber" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.notReceivedNumber}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="当前收货数量" prop="nowCount" align="center">
                </el-table-column>
                <!-- <el-table-column label="订单日期" prop="createTime" align="center" width="100px">
                </el-table-column> -->
                <el-table-column label="要求到货时间" prop="requireTime" :formatter="dateFormat" align="center" width="120px">
                </el-table-column>
                <el-table-column label="实际到货时间" prop="orderRealTime" align="center" width="100px">
                </el-table-column>
                <el-table-column label="超期天数" prop="overdueDay" align="center" width="120px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.overdueDay > 0">延期 {{ scope.row.overdueDay }}</span>
                        <span v-if="scope.row.overdueDay < 0 && scope.row.orderRealTime">提前 {{ -scope.row.overdueDay }}</span>
                        <span v-if="scope.row.overdueDay == 0"></span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="是否提交质检" prop="digitFlag" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.digitFlag == false"> 否</span>
                        <span v-if="scope.row.digitFlag == true"> 是 </span>
                    </template>
                </el-table-column> -->
                <el-table-column label="供应商" prop="supplier" align="center">
                </el-table-column>
                <el-table-column label="采购员" prop="buyerName" align="center" width="100px">
                </el-table-column>
                <el-table-column label="token" prop="token" align="center">
                </el-table-column>
                <el-table-column label="操作" min-width="80" fixed="right">
                    <template slot-scope="scope">
                        <div class="Receivingtake-box">
                            <div class="houseStyle imageObj" v-authority="'BACK_MENU3_M24_B5'" title="详情" :style="'background-image:url(' + $imageObj.check + ')'" @click="deliveryDetail(scope.row)"></div>
                        </div>
                    </template>
                </el-table-column>
            </h-table>
        </box>
        <!-- 数量调整 -->
        <el-dialog title="数量调整" :visible.sync="isReceivingDetail" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false" :show-close="false" @click.stop>
            <el-form v-if="IncomingReceivingIsShow" label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道编号" class="EL-Form-Item">
                        <el-select v-model="deliverySearch.whCode" placeholder="请选择">
                            <el-option v-for="item in warehouseList" :key="item.whId" :label="item.whCode+'-'+item.whName" :value="item.whCode">{{item.whCode}}-{{item.whName}}</el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="单据号" class="EL-Form-Item">
                        <el-input v-model="deliverySearch.orderCode" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="deliverySearch.matCode" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="deliverySearch.fcCode">
                    <el-form-item label="供应商" class="EL-Form-Item">
                        <el-input v-model="deliverySearch.supply" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getOrderDeliveryList">查询</el-button>
                        <el-button class="btn-t-delete" @click="deliveryReset()">重置</el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="!deliverySearch.fcCode">
                    <el-form-item label="供应商" class="EL-Form-Item">
                        <el-input v-model="deliverySearch.supply" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="收货单号" class="EL-Form-Item">
                        <el-input v-model="deliverySearch.odCode" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="质检状态" class="EL-Form-Item">
                        <el-select v-model="deliverySearch.checkStatus" placeholder="请选择" clearable="clearable">
                            <el-option label="待检" value="WAIT" />
                            <el-option label="免检" value="1" />
                            <el-option label="合格" value="OK" />
                            <el-option label="不合格" value="NOK" />
                            <el-option label="挑选" value="PICK" />
                            <el-option label="挑选完成" value="COMPLETE" />
                            <el-option label="关闭" value="CLOSE" />
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="deliverySearch.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions1"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="deliverySearch.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions2"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-col :lg="8" :xl="8" :offset="16">
                <el-button v-authority="'XCMENUCODE'" class="btn-t-edit" @click="updateOrderQuan">
                    数量调整
                </el-button>
                <el-button :loading="downloadLoadingPrint" class="btn-t-edit" type="primary" v-authority="'XCMENUCODE'" @click="rePrintNumber()">
                    <div class="houseStyle" :style="'background-image:url(' + $imageObj.print + ')'"></div>
                    <span class="houseSpan">标签打印</span>
                </el-button>
                <el-button :loading="downloadLoadingDelivery" class="btn-t-edit export" type="primary" v-authority="'XCMENUCODE'" @click="downLoadFileDelivery()">
                    <i class="el-icon-upload2"></i>
                    导出EXCEL
                </el-button>
            </el-col>
            <el-col :lg="24" :xl="24">
                <hr style="margin-bottom:1%" />
            </el-col>
            <h-table :headerCellStyle="deliveryData.headerCellStyle" :row-class-name="tableRowClassNames" :style="$popups.harvestRecordStyle(0.6)" @pageChange="getOrderDeliveryList" :data="deliveryData.data" pagination :nowPage.sync="deliverySearch.pageNum" :pageSize.sync="deliverySearch.pageSize" :total.sync="deliveryData.total" @selectionChange="selectAllDel">
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column label="通道编号" prop="whCode" align="center">
                </el-table-column>
                <el-table-column label="单据号" prop="orderCode" align="center">
                </el-table-column>
                <el-table-column label="收货单号" prop="odCode" align="center">
                </el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center">
                </el-table-column>
                <el-table-column label="物料描述" prop="matName" align="center">
                </el-table-column>
                <el-table-column label="收货数量" prop="matNum" align="center">
                </el-table-column>
                <el-table-column label="调整收货数量" prop="matQuan" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.sqResult == 'WAIT'">
                            <span v-if="scope.row.clicktextss">
                                <el-input v-model="scope.row.matQuan" oninput="value=value.replace(/[^\d]/g,'')">
                                </el-input>
                            </span>
                            <span v-else>
                                {{ scope.row.matQuan }}
                                <span @click="tabClickss(scope.row)" v-authority="'BACK_MENU_UPDATE'"><i class="el-icon-edit"></i></span>
                            </span>
                        </span>
                        <span v-else>
                            {{ scope.row.matQuan }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="原始批次号" prop="oldBatchNo" align="center">
                </el-table-column>
                <el-table-column label="新批次号" prop="newBatchNo" align="center">
                </el-table-column>
                <el-table-column label="收货库位" prop="laCode" align="center">
                </el-table-column>
                <el-table-column label="包装箱号" prop="boxCode" align="center">
                </el-table-column>
                <!-- <el-table-column label="计量单位" prop="matUnit" align="center">
                </el-table-column> -->
                <el-table-column label="物料属性" prop="matType" align="center">
                </el-table-column>
                <el-table-column label="质检状态" prop="sqResult" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.sqResult == '' || scope.row.sqResult == undefined">免检</span>
                        <span v-if="scope.row.sqResult == 'OK'">合格</span>
                        <span v-if="scope.row.sqResult == 'NOK'">不合格</span>
                        <span v-if="scope.row.sqResult == 'PICK'">挑选</span>
                        <span v-if="scope.row.sqResult == 'WAIT'">待检</span>
                        <span v-if="scope.row.sqResult == 'COMPLETE'">挑选完成</span>
												<span v-if="scope.row.sqResult == 'CLOSE'">关闭</span>
                    </template>
                </el-table-column>
                <el-table-column label="合格数量" prop="goodNumber" align="center">
                </el-table-column>
                <el-table-column label="不合格数量" prop="badNumber" align="center">
                </el-table-column>
                <el-table-column label="规值" prop="matSpecs" align="center">
                </el-table-column>
                <el-table-column label="钢号" prop="steelGrade" align="center">
                </el-table-column>
                <el-table-column label="炉号" prop="heatNumber" align="center">
                </el-table-column>
                <el-table-column label="采购入库时间" prop="odStockTime" align="center">
                </el-table-column>
                <el-table-column label="生产日期" prop="matProduceTime" align="center">
                </el-table-column>
                <el-table-column label="保质期" prop="matQualityTime" align="center">
                </el-table-column>
                <el-table-column label="有效期" prop="matEffectiveTime" align="center">
                </el-table-column>
                <el-table-column label="创建时间" prop="createTime" align="center">
                </el-table-column>
                <el-table-column label="要求到货时间"  prop="requireTime" :formatter="dateFormat" align="center">
                </el-table-column>
                <el-table-column label="收货人" prop="person" align="center">
                </el-table-column>
                <el-table-column label="是否提交质检给数字化工厂" prop="submitCheckFlag" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.submitCheckFlag == false"> 否</span>
                        <span v-if="scope.row.submitCheckFlag == true"> 是 </span>
                    </template>
                </el-table-column>
                <el-table-column label="供货商" prop="supplier" align="center">
                </el-table-column>
            </h-table>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="isReceivingDetail = false" class="btn-t-info">取 消</el-button>
            </span>
        </el-dialog>

        <!-- 订单同步 -->
        <el-dialog title="订单同步" :visible.sync="isReceivingDetails" class="fromDialog" :style="$popups.popups(0.2,0.25)" :close-on-click-modal="false" :show-close="false" @click.stop>
            <el-form label-position="right" label-width="80px">
                <el-form-item label="单据号" prop="tableOrderCode" class="EL-Form-Item" >
                    <el-input v-model="tableOrderCode" placeholder="请输入">
                        </el-input>
                </el-form-item>
            </el-form>
        
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="isReceivingDetails = false" class="btn-t-info">取 消</el-button>
                <el-button @click="synchronization()" class="btn-t-edit">确 认</el-button>
            </span>
        </el-dialog>

        <!-- 收货框 -->
        <el-dialog title="收货" :visible.sync="deliveryInShow" class="fromDialog" :close-on-click-modal="false" :show-close="false" @click.stop :style="$popups.popups(0.8,0.9)">
            <div>
                <el-form label-position="right" label-width="100px" :model="deliveryInData" :rules="rules" ref="deliveryInData" class="EL-Form">
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="采购订单号" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.orderCode" disabled> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="物料编号" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.matCode" placeholder="物料编号">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="物料描述" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.matName" placeholder="物料描述">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :lg="5" :xl="5">
                        <el-form-item label="原始批次号" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.oldBatchNo" placeholder="原始批次号">
                            </el-input>
                        </el-form-item>
                    </el-col> -->
                    <!--<el-col :lg="5" :xl="5">
                        <el-form-item label="保质期（月）" class="EL-Form-Item">
                            <el-input v-model="matInfo.validityMonth" placeholder="保质期（月）" disabled>
                            </el-input>
                        </el-form-item>
                    </el-col>-->
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="订单总数量" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.orderQuan" placeholder="当前收货总量" disabled>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="剩余收货数量" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.surplusCount" placeholder="当前收货总量" disabled>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="当前收货总量" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.quanCount" placeholder="当前收货总量" disabled>
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <!-- <el-col :lg="5" :xl="5">
                        <el-form-item label="生产日期" class="EL-Form-Item">
                            <el-date-picker v-model="deliveryInData.matProduceTime" type="date" value-format="yyyy-MM-dd" placeholder="生产日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col> -->
                </el-form>
                <el-col :lg="24" :xl="24">
                    <hr style="margin:0; margin-bottom:1%" />
                </el-col>
                <el-form label-position="right" label-width="80px" :model="deliveryInData" :rules="rules" ref="deliveryInData" class="EL-Form">
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="每箱数量" prop="matStandNumber" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.matStandNumber" @change="deliveryInDataNum('matStandNumber')" oninput="value=value.replace(/[^\d]/g,'')">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="箱数" prop="matQualityNumber" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.matQualityNumber" @change="deliveryInDataNum('matQualityNumber')" oninput="value=value.replace(/[^\d]/g,'')">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="收货数量" prop="matQuan" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.matQuan" @change="deliveryInDataNum('matQuan')" oninput="value=value.replace(/[^\d]/g,'')">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="批次号" prop="newBatchNo" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.newBatchNo" placeholder="批次号">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="规值" prop="matSpecs" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.matSpecs" placeholder="规值">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :lg="5" :xl="5">
                        <el-form-item label="地面库位" prop="steelGrade" class="EL-Form-Item" v-if="deliveryInData.mtCheck=='40'">
                            <el-select v-model="deliveryInData.laCode" placeholder="请选择" clearable filterable>
                                <el-option v-for="item in laGroundList" :key="item.lcId" :label="item.lcCode" :value="item.lcCode">{{item.lcCode}}</el-option>
                            </el-select>
                        </el-form-item>
                    </el-col> -->
                    <!--<el-col :lg="5" :xl="5">
                        <el-form-item label="钢号" prop="steelGrade" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.steelGrade" placeholder="钢号">
                            </el-input>
                        </el-form-item>
                    </el-col>-->
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="热处理炉号" prop="heatNumber" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.heatNumber" placeholder="炉号">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="托盘类型" prop="" class="EL-Form-Item">
                            <el-select v-model="deliveryInData.boxHeight " placeholder="请选择">
                                <el-option v-for="item in tierHigh" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="打印张数" class="EL-Form-Item">
                            <el-select v-model="deliveryInData.printTwo" placeholder="请选择" clearable filterable>
                                <el-option label="一张" :value="false">一张</el-option>
                                <el-option label="两张" :value="true">两张</el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="4" :xl="4">
                        <el-button class="btn-t-edit" @click="insertOrderDelivery()" type="primary" :loading="loadingbut">
                            {{ loadingbuttext }}
                        </el-button>
                        <el-button class="btn-t-delete" @click="deliveryDetailDel()" type="danger">
                            删除
                        </el-button>
                    </el-col>
                    <!-- <el-col :lg="5" :xl="5">
                        <el-form-item label="库位" prop="steelGrade" class="EL-Form-Item" v-if="checkFlag== false">
                            <el-select v-model="deliveryInData.laCode" placeholder="请选择" clearable filterable>
                                <el-option v-for="item in lcCodeList" :key="item.lcId" :label="item.laType" :value="item.laType" >{{item.laType}}</el-option>
                            </el-select>
                        </el-form-item>
                    </el-col> -->
                </el-form>
            </div>
            <!-- 收货记录 -->
            <h-table :headerCellStyle="deliveryDetailData.headerCellStyle" :style="$popups.harvestRecordStyle(0.46)" :data="deliveryDetailData.data" class="harvestRecord" @selectionChange="selectAllDelete">
                <el-table-column type="selection" align="center"></el-table-column>
                <!-- <el-table-column label="序号" type="index" width="50"></el-table-column> -->
                <el-table-column label="采购订单号" prop="orderCode" align="center">
                </el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center">
                </el-table-column>
                <el-table-column label="物料描述" prop="matName" align="center">
                </el-table-column>
                <el-table-column label="收货数量" prop="matQuan" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.clicktext">
                            <el-input v-model="scope.row.matQuan" @blur="updateBoxQuan(scope.row)" @change="deliveryInDataNum('matQuan')" oninput="value=value.replace(/[^\d]/g,'')">
                            </el-input>
                        </span>
                        <span v-else>
                            {{ scope.row.matQuan }}
                            <span @click="tabClick(scope.row)" v-authority="'BACK_MENU_UPDATE'"><i class="el-icon-edit"></i></span>
                        </span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="原始批次号" prop="oldBatchNo" align="center">
                </el-table-column> -->
                <el-table-column label="批次号" prop="newBatchNo" align="center" width="110">
                    <template slot-scope="scope">
                        <span v-if="scope.row.newBach">
                            <el-input v-model="scope.row.newBatchNo" @blur="updateBoxQuan(scope.row)">
                            </el-input>
                        </span>
                        <span v-else>
                            {{ scope.row.newBatchNo }}
                            <span @click="newBachClick(scope.row)" v-authority="'BACK_MENU_UPDATE'"><i class="el-icon-edit"></i></span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="收货暂存库位" prop="laCode" align="center" v-if="deliveryInData.mtCheck=='20'">
                </el-table-column>
                <el-table-column label="收货条码" prop="boxCode" align="center">
                </el-table-column>
                <el-table-column label="规值" prop="matSpecs" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.clicktexts">
                            <el-input v-model="scope.row.matSpecs" @blur="updateBoxQuan(scope.row)">
                            </el-input>
                        </span>
                        <span v-else>
                            {{ scope.row.matSpecs }}
                            <span @click="tabClicks(scope.row)" v-authority="'BACK_MENU_UPDATE'"><i class="el-icon-edit"></i></span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="托盘类型" prop="boxHeight" align="center">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.boxHeight " placeholder="请选择" @change="updateBoxQuan(scope.row)">
                            <el-option v-for="item in tierHigh" :key="item.value" :label="item.label" :value="item.value" >
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="钢号" prop="steelGrade" align="center">
                     <template slot-scope="scope">
                         <span v-if="scope.row.clicksteelGrade">
                             <el-input v-model="scope.row.steelGrade" @blur="updateBoxQuan(scope.row)">
                             </el-input>
                         </span>
                         <span v-else>
                             {{ scope.row.steelGrade }}
                             <span @click="steelGradeClick(scope.row)" v-authority="'BACK_MENU_UPDATE'"><i class="el-icon-edit"></i></span>
                         </span>
                     </template>
                 </el-table-column>-->
                <el-table-column label="热处理炉号" prop="heatNumber" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.clickheatNumber">
                            <el-input v-model="scope.row.heatNumber" @blur="updateBoxQuan(scope.row)">
                            </el-input>
                        </span>
                        <span v-else>
                            {{ scope.row.heatNumber }}
                            <span @click="heatNumberClick(scope.row)" v-authority="'BACK_MENU_UPDATE'"><i class="el-icon-edit"></i></span>
                        </span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="计量单位" prop="matUnit" align="center">
                </el-table-column> -->
                <el-table-column label="采购入库时间" prop="odStockTime" align="center" width="100px">
                </el-table-column>
                <!-- <el-table-column label="生产日期" prop="matProduceTime" :formatter="dateFormat" align="center" width="100px">
                </el-table-column> -->
                <!-- <el-table-column label="保质期" prop="matQualityTime" align="center">
                </el-table-column>-->
                <!-- <el-table-column label="有效期" prop="matEffectiveTime" :formatter="dateFormat" align="center">
                </el-table-column>-->
                <el-table-column label="操作" min-width="120" fixed="right">
                    <template slot-scope="scope">
                        <el-button class="btn-t-delete" @click="deliveryDetailDel(scope.row.odId)" :disabled="scope.row.odStatus == 'EXECUTE' ? false : true">删除</el-button>
                    </template>
                </el-table-column>
            </h-table>

            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="orderClose" type="info" class="btn-t-info">取 消</el-button>
                <el-button :loading="confrimOrderDeliverys" @click="confrimOrderDelivery(deliveryInData.orderCode)" type="primary" class="btn-t-edit" :disabled="this.deliveryDetailData.data.length == 0">确认收货</el-button>
            </div>
        </el-dialog>

                <!-- 收货框 -->
        <el-dialog title="寄售收货" :visible.sync="orderMesReceiptDialogShow" class="fromDialog" :close-on-click-modal="false" :show-close="false" @click.stop :style="$popups.popups(0.8,0.9)">
            <div>
                <el-form label-position="right" label-width="100px" :model="deliveryInData" :rules="rules" ref="deliveryInData" class="EL-Form">
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="采购订单号" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.orderCode" disabled> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="物料编号" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.matCode" placeholder="物料编号">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="物料描述" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.matName" placeholder="物料描述">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="订单总数量" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.orderQuan" placeholder="当前收货总量" disabled>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="剩余收货数量" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.surplusCount" placeholder="当前收货总量" disabled>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="当前收货总量" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.quanCount" placeholder="当前收货总量" disabled>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-form>
                <el-col :lg="24" :xl="24">
                    <hr style="margin:0; margin-bottom:1%" />
                </el-col>
                <el-form label-position="right" label-width="80px" :model="deliveryInData" :rules="rules" ref="deliveryInData" class="EL-Form">
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="每箱数量" prop="matStandNumber" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.matStandNumber" @change="deliveryInDataNum('matStandNumber')" oninput="value=value.replace(/[^\d]/g,'')">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="箱数" prop="matQualityNumber" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.matQualityNumber" @change="deliveryInDataNum('matQualityNumber')" oninput="value=value.replace(/[^\d]/g,'')">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="收货数量" prop="matQuan" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.matQuan" @change="deliveryInDataNum('matQuan')" oninput="value=value.replace(/[^\d]/g,'')">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="批次号" prop="newBatchNo" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.newBatchNo" placeholder="批次号">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="规值" prop="matSpecs" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.matSpecs" placeholder="规值">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="热处理炉号" prop="heatNumber" class="EL-Form-Item">
                            <el-input v-model="deliveryInData.heatNumber" placeholder="炉号">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="托盘类型" prop="" class="EL-Form-Item">
                            <el-select v-model="deliveryInData.boxHeight " placeholder="请选择">
                                <el-option v-for="item in tierHigh" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="打印张数" class="EL-Form-Item">
                            <el-select v-model="deliveryInData.printTwo" placeholder="请选择" clearable filterable>
                                <el-option label="一张" :value="false">一张</el-option>
                                <el-option label="两张" :value="true">两张</el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="4" :xl="4">
                        <el-button class="btn-t-edit" @click="insertOrderDelivery()" type="primary" :loading="loadingbut">
                            {{ loadingbuttext }}
                        </el-button>
                        <el-button class="btn-t-delete" @click="deliveryDetailDel()" type="danger">
                            删除
                        </el-button>
                    </el-col>
                </el-form>
            </div>
            <!-- 收货记录 -->
            <h-table :headerCellStyle="deliveryDetailData.headerCellStyle" :style="$popups.harvestRecordStyle(0.46)" :data="deliveryDetailData.data" class="harvestRecord" @selectionChange="selectAllDelete">
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column label="采购订单号" prop="orderCode" align="center">
                </el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center">
                </el-table-column>
                <el-table-column label="物料描述" prop="matName" align="center">
                </el-table-column>
                <el-table-column label="收货数量" prop="matQuan" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.clicktext">
                            <el-input v-model="scope.row.matQuan" @blur="updateBoxQuan(scope.row)" @change="deliveryInDataNum('matQuan')" oninput="value=value.replace(/[^\d]/g,'')">
                            </el-input>
                        </span>
                        <span v-else>
                            {{ scope.row.matQuan }}
                            <span @click="tabClick(scope.row)" v-authority="'BACK_MENU_UPDATE'"><i class="el-icon-edit"></i></span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="批次号" prop="newBatchNo" align="center" width="110">
                    <template slot-scope="scope">
                        <span v-if="scope.row.newBach">
                            <el-input v-model="scope.row.newBatchNo" @blur="updateBoxQuan(scope.row)">
                            </el-input>
                        </span>
                        <span v-else>
                            {{ scope.row.newBatchNo }}
                            <span @click="newBachClick(scope.row)" v-authority="'BACK_MENU_UPDATE'"><i class="el-icon-edit"></i></span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="收货暂存库位" prop="laCode" align="center" v-if="deliveryInData.mtCheck=='20'">
                </el-table-column>
                <el-table-column label="收货条码" prop="boxCode" align="center">
                </el-table-column>
                <el-table-column label="规值" prop="matSpecs" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.clicktexts">
                            <el-input v-model="scope.row.matSpecs" @blur="updateBoxQuan(scope.row)">
                            </el-input>
                        </span>
                        <span v-else>
                            {{ scope.row.matSpecs }}
                            <span @click="tabClicks(scope.row)" v-authority="'BACK_MENU_UPDATE'"><i class="el-icon-edit"></i></span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="托盘类型" prop="boxHeight" align="center">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.boxHeight " placeholder="请选择" @change="updateBoxQuan(scope.row)">
                            <el-option v-for="item in tierHigh" :key="item.value" :label="item.label" :value="item.value" >
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="热处理炉号" prop="heatNumber" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.clickheatNumber">
                            <el-input v-model="scope.row.heatNumber" @blur="updateBoxQuan(scope.row)">
                            </el-input>
                        </span>
                        <span v-else>
                            {{ scope.row.heatNumber }}
                            <span @click="heatNumberClick(scope.row)" v-authority="'BACK_MENU_UPDATE'"><i class="el-icon-edit"></i></span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="采购入库时间" prop="odStockTime" align="center" width="100px">
                </el-table-column>
                <el-table-column label="操作" min-width="120" fixed="right">
                    <template slot-scope="scope">
                        <el-button class="btn-t-delete" @click="deliveryDetailDel(scope.row.odId)" :disabled="scope.row.odStatus == 'EXECUTE' ? false : true">删除</el-button>
                    </template>
                </el-table-column>
            </h-table>

            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="orderMesReceiptCLose" type="info" class="btn-t-info">取 消</el-button>
                <el-button :loading="confrimOrderDeliverys" @click="confrimOrderDeliveryConsignment(deliveryInData.orderCode)" type="primary" class="btn-t-edit" :disabled="this.deliveryDetailData.data.length == 0">确认收货</el-button>
            </div>
        </el-dialog>

        <!-- 收货详情 -->
        <el-dialog title="收货详情" :visible.sync="deliveryDetailShow" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false" :show-close="false">
            <el-row>
                <el-col :lg="3" :xl="3" :offset="21" style="padding:10px 0">
                    <el-button @click="rePrintBarcode()" class="btn-t-edit" v-if="deliveryDetailSearch.saleFlag == false">标签打印</el-button>
                </el-col>
            </el-row>
            <h-table :headerCellStyle="deliveryDetailData.headerCellStyle" :style="$popups.harvestRecordStyle(0.73)" @pageChange="getOrderDeliveryDetail" :data="deliveryDetailData.data" pagination :nowPage.sync="deliveryDetailData.pageNum" :pageSize.sync="deliveryDetailData.pageSize" :total.sync="deliveryDetailData.total" @selectionChange="selectAllPrint" v-if="deliveryDetailSearch.saleFlag == false">
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column label="入库单号" prop="orderCode" align="center"></el-table-column>
                <el-table-column label="收货单号" prop="odCode" align="center"></el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center"></el-table-column>
                <el-table-column label="物料描述" prop="matName" align="center"></el-table-column>
                <el-table-column label="收货数量" prop="matQuan" align="center"></el-table-column>
                <el-table-column label="原始批次号" prop="oldBatchNo" align="center"></el-table-column>
                <el-table-column label="新批次号" prop="newBatchNo" align="center"></el-table-column>
                <el-table-column label="包装箱号" prop="boxCode" align="center"></el-table-column>
                <el-table-column label="收货状态" prop="odStatus" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.odStatus == 'EXECUTE'">收货中</span>
                        <span v-if="scope.row.odStatus == 'WAITCHECK'">待检</span>
                        <span v-if="scope.row.odStatus == 'CHECKING'">检验中</span>
                        <span v-if="scope.row.odStatus == 'WAIT'">待入库</span>
                        <span v-if="scope.row.odStatus == 'INPUT'">已入库</span>
                        <span v-if="scope.row.odStatus == 'WAITRETURN'">待退货</span>
                        <span v-if="scope.row.odStatus == 'RETURNED'">已退货</span>
                    </template>
                </el-table-column>
                <el-table-column label="采购入库时间" prop="odStockTime" align="center" width="100px"></el-table-column>
                <el-table-column label="规值" prop="matSpecs" align="center"></el-table-column>
                <el-table-column label="钢号" prop="steelGrade" align="center"></el-table-column>
                <el-table-column label="炉号" prop="heatNumber" align="center"></el-table-column>
                <!-- <el-table-column label="计量单位" prop="matUnit" align="center"></el-table-column> -->
                <el-table-column label="物料属性" prop="matType" align="center"></el-table-column>
                <el-table-column label="生产日期" prop="matProduceTime" align="center" width="100px"></el-table-column>
                <el-table-column label="有效期" prop="matEffectiveTime" align="center" width="100px"></el-table-column>
                <el-table-column label="保质期" prop="matQualityTime" align="center" width="100px"> 
                </el-table-column>
                <el-table-column label="创建时间" prop="createTime" align="center" width="100px"></el-table-column>
            </h-table>
            <h-table :headerCellStyle="deliveryDetailData.headerCellStyle" :style="$popups.harvestRecordStyle(0.73)" @pageChange="getOrderDetailByMes" :data="deliveryDetailData.data" pagination :nowPage.sync="deliveryDetailData.pageNum" :pageSize.sync="deliveryDetailData.pageSize" :total.sync="deliveryDetailData.total" v-if="deliveryDetailSearch.saleFlag == true">
                <el-table-column label="送货单号" prop="mrCode" align="center"></el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center"></el-table-column>
                <el-table-column label="物料名称" prop="matName" align="center"></el-table-column>
                <el-table-column label="物料描述" prop="matDesc" align="center"></el-table-column>
                <el-table-column label="采购数量" prop="orderQuan" align="center"></el-table-column>
                <el-table-column label="箱号" prop="boxBarcode" align="center"></el-table-column>
                <el-table-column label="工厂" prop="fcCode" align="center"></el-table-column>
                <el-table-column label="供应商" prop="supplierCode" align="center"></el-table-column>
                <el-table-column label="批次号" prop="batchNo" align="canter"></el-table-column>
                <el-table-column label="通道" prop="whCode" align="center" width="100px"></el-table-column>
                <el-table-column label="订单创建时间" prop="createTime" align="center" width="100px"></el-table-column>
            </h-table>

            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="deliveryClose" type="info" class="btn-t-info">取 消</el-button>
            </div>
        </el-dialog>

        <!-- 寄售收货 -->
        <!-- <el-dialog title="寄售收货" :visible.sync="orderMesReceiptDialogShow" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false" :show-close="false">
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="订单编号" class="EL-Form-Item">
                        <el-input v-model="orderMesReceiptSearchInfo.orderCode" disabled />
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-select v-model="orderMesReceiptSearchInfo.matCode" placeholder="请选择" filterable>
                            <el-option v-for="item in orderMesReceiptSearchInfo.materialGroupList" :key="item.mtId" :label="item.mtCode+'-'+item.mtName" :value="item.mtCode" @click.native="changeMaterialGroup(item)"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="" class="EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getOrderMesReceiptDetails()">查询</el-button>
                    </el-form-item>
                </el-col>
            </el-form>
            <h-table :headerCellStyle="orderMesReceiptDetail.headerCellStyle" :style="$popups.harvestRecordStyle(0.70)" @pageChange="getOrderMesReceiptDetails()" :data="orderMesReceiptDetail.data"
                     pagination :nowPage.sync="orderMesReceiptDetail.pageNum" :pageSize.sync="orderMesReceiptDetail.pageSize" :total.sync="orderMesReceiptDetail.total" @selectionChange="selectOrderMesReceipt">
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column label="送货单号" prop="mrCode" align="center"></el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center"></el-table-column>
                <el-table-column label="物料名称" prop="matName" align="center"></el-table-column>
                <el-table-column label="物料描述" prop="matDesc" align="center"></el-table-column>
                <el-table-column label="收货数量" prop="matQuan" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.clicktext">
                            <el-input v-model="scope.row.matQuan" oninput="value=value.replace(/[^\d]/g,'')"/>
                        </span>
                        <span v-else>
                            {{ scope.row.matQuan }}
                            <span @click="tabClick(scope.row)" v-authority="'BACK_MENU_UPDATE'"><i class="el-icon-edit"></i></span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="箱号" prop="boxBarcode" align="center"></el-table-column>
                <el-table-column label="工厂" prop="fcCode" align="center"></el-table-column>
                <el-table-column label="供应商" prop="supplierCode" align="center"></el-table-column>
                <el-table-column label="批次" prop="batchNo" align="center"></el-table-column>
                <el-table-column label="通道" prop="whCode" align="center" width="100px"></el-table-column>
                <el-table-column label="订单创建时间" prop="createTime" align="center" width="100px"></el-table-column>
            </h-table>

            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="orderMesReceiptCLose" type="info" class="btn-t-info">取 消</el-button>
                <el-button @click="orderMesReceiptConfirm" type="pramary" class="btn-t-edit" :disabled="orderMesReceiptDetail.selectList.length === 0" :loading="orderMesReceiptLoading">确 认</el-button>
            </div>
        </el-dialog> -->
    </div>
</template>
<style>
    .el-table .success-row {
        color: #ff0000;
    }
</style>
<script>
    import moment from "moment";
    import confluenceVue from '../reportData/confluence.vue';
    export default {
        name: "IncomingMaterialReceipt",
        data() {
            return {
                tableOrderCode:"",
                isReceivingDetails :false,
                isReceivingDetail: false,
                // 多选   选中要删除的数据
                AllDelete: "",
                storyHeight: "",
                whichStorey: 3,
                // 层高的下拉框
                tierHigh: [{
                    value: 0,
                    label: '非标'
                }, {
                    value: 1,
                    label: 'P01'
                }, {
                    value: 2,
                    label: 'P02'
                }, {
                    value: 3,
                    label: 'P03'
                }],
                // 控制搜索条件是否显示
                packUpIsShow: true,
                // 控制搜索条件是否显示
                IncomingReceivingIsShow: true,
                //按钮提交中
                loadingbut: false,
                loadingbuttext: "收货",
                orderSearch: {
                    query: {
                        saleFlag: true,
                        whCode: "",
                        fcCode: localStorage.getItem("fcCode") || "",
                        orderCode: "",
                        supply: "",
                        buyer: "",
                        matCode: "",
                        matName: "",
                        beginTime: "",
                        endTime: "",
                        orderStatus: "EXECUTE"
                    },
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    data: [],
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                factoryList: [],
                deliveryData: {
                    data: [],
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                deliverySearch: {
                    whCode: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    odCode: "",
                    orderCode: "",
                    supply: "",
                    laCode: "",
                    matCode: "",
                    matName: "",
                    person: "",
                    status: "",
                    checkStatus: "WAIT",
                    date: [],
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                },
                whCodeId: "",
                deliveryDetailData: {
                    data: [],
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    printTwo: false,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                deliveryDetailSearch: {
                    saleFlag: true,
                    odCode: "",
                    orderCode: "",
                },
                deliveryInShow: false,
                deliveryInData: {
                    matProduceTime: moment(new Date).format("YYYY-MM-DD"),
                    fcCode: "",
                    orderCode: "",
                    odStockTime: "",
                    matCode: "",
                    matQuan: "",
                    oldBatchNo: "",
                    matQualityTime: "",
                    boxHeight: "",
                    matQualityNumber: "",
                    person: "",
                    matStandNumber: "",
                    matSpecs: "",
                    matLenValue: "",
                    newBatchNo: "",
                    odCode: "",
                    quanCount: 0,
                    whCode: "",
                    supplier: "",
                    steelGrade: "", //钢号
                    heatNumber: "", //炉号
                    surplusCount: 0, //剩余收货数量
                    laCode: "",
                    mtCheck: "",
                    matUnit: "",
                    printTwo: false,
                    lineNo:"",  //订单项次
                },
                odcCOde: "",
                arr: {},
                //收货明细
                checkList: [],

                //订单详情
                checkLists: [],
                deliveryDetailShow: false,
                isQuality: false, //是否质检

                rules: {
                    matCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    matStandNumber: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    matQualityNumber: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    newBatchNo: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                },
                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注

                matInfo: {}, //物料基础数据

                inputNumber: false,
                inputNumberTwo: false,

                //下载中
                downloadLoading: false,
                downloadLoadingDelivery: false,
                downloadLoadingPrint: false,
                confrimOrderDeliverys: false,

                //通道集合
                warehouseList: [],
                //库位
                lcCodeList: [],
                //地面库位
                laGroundList:[],

                //打印
                lazyNext: null,
                lazyNexts: null,

                //标签打印
                selectAllPrintList: [],
                // 输入框延时加载
                isSetTimeout: null,

                // 库位号查询动态加载
                lcCodeLoading: false,

                //订单物料质检项
                checkFlag:"",

                //寄售收货
                orderMesReceiptDialogShow: false,
                orderMesReceiptSearchInfo: {
                    fcCode: localStorage.getItem("fcCode") || "",
                    whCode: localStorage.getItem("whCode") || "",
                    orderCode: '',
                    matCode: '',
                    supplierCode: '',
                    saleFlag: true, //寄售
                    materialGroupList: [],
                    materialGroupVendorList: [],
                },
                orderMesReceiptDetail: {
                    data: [],
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    selectList: [],
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                orderMesReceiptLoading: false,
            };
        },
        watch: {
            "orderSearch.query": {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getOrderList(newVal);
                    }, 1000);
                },
                deep: true,
            },
            deliverySearch: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getOrderDeliveryList(newVal);
                    }, 1000);
                },
                deep: true,
            },
        },
        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.orderSearch.beginTime) {
                            return time.getTime() < new Date(_this.orderSearch.beginTime);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.orderSearch.endTime) {
                            return time.getTime() > new Date(_this.orderSearch.endTime);
                        }
                    }
                }
            },
            pickerOptions1() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.deliverySearch.date[0]) {
                            return time.getTime() < new Date(_this.deliverySearch.date[0]);
                        }
                    }
                }
            },
            pickerOptions2() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.deliverySearch.date[1]) {
                            return time.getTime() > new Date(_this.deliverySearch.date[1]);
                        }
                    }
                }
            },
        },

        methods: {
            /**
             * 订单(寄售+非寄售)
             */
            getOrderList() {
                clearTimeout(this.isSetTimeout)

                this.$http
                    .request({
                        url: "/api/order/getOrderList",
                        method: "GET",
                        params: {
                            pageNum: this.orderSearch.pageNum,
                            pageSize: this.orderSearch.pageSize,
                            saleFlag: this.orderSearch.query.saleFlag,
                            whCode: this.orderSearch.query.whCode || null,
                            // fcCode: this.orderSearch.query.fcCode || null,
                            orderCode: this.orderSearch.query.orderCode || null,
                            supplierCode: this.orderSearch.query.supply || null,
                            buyer: this.orderSearch.query.buyer || null,
                            matCode: this.orderSearch.query.matCode || null,
                            matName: this.orderSearch.query.matName || null,
                            orderStatus: this.orderSearch.query.orderStatus || null,
                            beginTime: this.orderSearch.query.beginTime || null,
                            endTime: this.orderSearch.query.endTime || null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.orderSearch.data = resp.data.list || [];
                            this.orderSearch.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败" + resp.message,
                            type: "warning",
                        });
                    });
            },

            /**
             * 同步工单
             */
            synchronization(){
                if(this.tableOrderCode == "" || this.tableOrderCode.length != 7){
                    this.$message({
                        message: "请填写正确的采购编号!",
                        type: "warning",
                    });
                    return
                }

                this.$http
                    .request({
                        url: "/api/order/synchronization",
                        method: "POST",
                        showLoading: true,
                        params:{
                            orderCode:this.tableOrderCode.toUpperCase(),
                        }
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.$message({
                                message: "同步成功",
                                type: "success",
                            });
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    })

            },
            /* 远程搜索库位号 */
            remoteMethodLcCode(query) {
                if (query || query == 0) {
                    this.lcCodeLoading = true;
                    this.getSysLocationAll(query);
                    setTimeout(() => {
                        this.lcCodeLoading = false;
                        if (this.lcCodeList != undefined) {
                            this.lcCodeList = this.lcCodeList.filter((item) => {
                                return (item.lcCode.toLowerCase().indexOf(query.toLowerCase()) > -1);
                            });
                        }
                    }, 200);
                } else {
                    this.lcCodeList = [];
                }
            },
            /* 获取所有的库位 */
            getSysLocationAll(lcCode) {
                this.$http
                    .request({
                        url: "/api/location/getLaCodeAllByType",
                        method: "GET",
                        params: {
                            lcType: "FLOOR,QC,PACK",
                            fcCode: localStorage.getItem("fcCode") || "",
                            lcCode: lcCode || "",
                        },
                    })
                    .then((resp) => {
                    if (resp.status == 100) {
                        if (resp.data && resp.data.list) {
                            this.lcCodeList = resp.data.list;
                        }else{
                            this.lcCodeList = [];
                        }
                    }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
             /* 获取所有的库位 */
            getSysLocation() {
                this.$http
                    .request({
                        url: "/api/location/getLaCodeAllByType",
                        method: "GET",
                        params: {
                            lcType: "FLOOR",
                            fcCode: localStorage.getItem("fcCode") || "",
                        },
                    })
                    .then((resp) => {
                    if (resp.status == 100) {
                        if (resp.data && resp.data.list) {
                            this.laGroundList = resp.data.list;
                        }else{
                            this.laGroundList = [];
                        }
                    }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            ReceivingDetail() {
                this.isReceivingDetail = true
            },
            deliveryInDataNum(type) {
                if (type == 'matQuan' && this.deliveryInData.matStandNumber && this.deliveryInData.matQualityNumber && this.deliveryInData.matQuan) {
                    this.deliveryInData.matQualityNumber = Math.ceil(this.deliveryInData.matQuan / this.deliveryInData.matStandNumber);
                } else {
                    if (this.deliveryInData.matStandNumber && this.deliveryInData.matQualityNumber) {
                        this.deliveryInData.matQuan = this.deliveryInData.matStandNumber * this.deliveryInData.matQualityNumber;
                    } else if (this.deliveryInData.matStandNumber && this.deliveryInData.matQuan) {
                        this.deliveryInData.matQualityNumber = Math.ceil(this.deliveryInData.matQuan / this.deliveryInData.matStandNumber);
                    } else if (this.deliveryInData.matQualityNumber && this.deliveryInData.matQuan) {
                        this.deliveryInData.matStandNumber = Math.ceil(this.deliveryInData.matQuan / this.deliveryInData.matQualityNumber);
                    }
                }
            },
            // 点击是否显示搜索结果
            packUpClick() {
                this.packUpIsShow = !this.packUpIsShow;
            },
            tabClick(row) {
                this.$set(row, "clicktext", true);
            },
            tabClicks(row) {
                this.$set(row, "clicktexts", true);
            },
            tabClickss(row) {
                this.$set(row, "clicktextss", true);
            },
            newBachClick(row) {
                this.$set(row, "newBach", true);
            },
            steelGradeClick(row) {
                this.$set(row, "clicksteelGrade", true);
            },
            heatNumberClick(row) {
                this.$set(row, "clickheatNumber", true);
            },
            /**
             * 1、如果提前5天 到的则标红。 
             */
            tableRowClassName({
                row
            }) {
                if (row.overdueDay < -5 && row.orderRealTime) {
                    return "success-row";
                }
            },

            /**
             * 来料收货待检超过5天的 标红
             */
            tableRowClassNames({
                row
            }) {
                var dates = new Date(row.createTime);
                var end = dates.getTime(); //日期转时间戳
                var today = Date.parse(new Date()); //当前的时间戳
                var days = (end - today) / (1000 * 3600 * 24);
                if (days < -5 && row.sqResult == "WAIT") {
                    return "success-row";
                }
            },
            /**
             * 应到时间格式化
             */
            dateFormat(row, column) {
                var date = row[column.property];
                if (date == undefined) {
                    return "";
                }
                return moment(date).format("YYYY-MM-DD HH:MM:SS");
            },

            /**
             * 来料收货
             */
            getOrderDeliveryList() {
                this.$http
                    .request({
                        url: "/api/order/getOrderDeliveryList",
                        method: "GET",
                        params: {
                            fcCode: this.deliverySearch.fcCode || null,
                            orderCode: this.deliverySearch.orderCode || null,
                            odCode: this.deliverySearch.odCode || null,
                            supply: this.deliverySearch.supply || null,
                            laCode: this.deliverySearch.laCode || null,
                            matCode: this.deliverySearch.matCode || null,
                            matName: this.deliverySearch.matName || null,
                            person: this.deliverySearch.person || null,
                            status: this.deliverySearch.status || null,
                            whCode: this.deliverySearch.whCode || null,
                            beginTime: this.deliverySearch.date ? this.deliverySearch.date[0] : null,
                            endTime: this.deliverySearch.date ? this.deliverySearch.date[1] : null,
                            pageNum: this.deliverySearch.pageNum,
                            pageSize: this.deliverySearch.pageSize,
                            checkStatus: this.deliverySearch.checkStatus
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.deliveryData.data = resp.data.list || [];
                            this.deliveryData.total = resp.data.total;
                            this.$set(this.deliveryData.data, "clicktextss", false);
                            if (this.deliveryData.total > 0) {
                                for (let e of this.deliveryData.data) {
                                    this.$set(e, "matNum", e.matQuan);
                                    if(e.submitCheckFlag == null){
                                        this.$set(e, "submitCheckFlag", false);
                                    }
                                    if(e.matQualityTime == 0){
                                        this.$set(e, "matQualityTime", 12);
                                        var date = new Date(e.matEffectiveTime);
                                        date.setFullYear(date.getFullYear()+1);
                                        this.$set(e, "matEffectiveTime", moment(date).format("YYYY-MM-DD HH:MM:SS"));
                                    }
                                }
                            }
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            /**
             * 收货——弹出框
             */
            deliveryIn() {
                if (!this.checkLists.length) {
                    this.$message({
                        message: "没有选择数据,请先选择需要收货的数据!",
                        type: "warning",
                    });
                    return
                } else if (this.checkLists.length > 0) {
                    if (this.checkLists[0].saleFlag != false) {
                        this.$message({
                            message: "请选择非寄售数据!",
                            type: "warning",
                        });
                        return
                    }
                }
                if (this.checkLists.length !== 1) {
                    this.$message({
                        message: "收货数据只能选择一条!",
                        type: "warning",
                    });
                    return
                }
                var row = this.checkLists[0];
                var num = row.orderArriveQuan - row.orderReturnQuan;
                if (num >= row.orderQuan) {
                    this.$message({
                        message: "当前订单收货数量到达，不能再进行收货！",
                        type: "warning",
                    });
                    return;
                }
                this.deliveryInData = {
                    quanCount: row.nowCount,
                    fcCode: row.fcCode,
                    matUnit: row.matUnit,
                    orderCode: row.orderCode,
                    boxCode: "",
                    matCode: row.matCode,
                    matName: row.matName,
                    matQuan: "",
                    newBatchNo: row.orderCode,
                    // oldBatchNo: row.orderCode,
                    oldBatchNo: "",
                    boxHeight: this.whichStorey,
                    matQualityNumber: "", //分装箱数
                    matStandNumber: "",
                    odStockTime: moment().format("YYYY-MM-DD HH:MM:SS"),
                    matProduceTime: moment(new Date).format("YYYY-MM-DD"),
                    whCode: row.whCode,
                    supplier: row.supplier,
                    orderQuan: row.orderQuan,
                    surplusCount: row.orderQuan - row.orderArriveQuan,
                    laCode: "",
                    mtCheck: row.mtCheck,
                    printTwo: false
                };

                //查询物料主数据
                this.getMaterialInfo(row.matCode);
                console.log(this.matInfo)

                //查询物料配置信息
                this.getSysMaterialGroup(row.supplier,row.fcCode,row.whCode,row.matCode);

                this.odcCOde = row.orderCode;

                //查看是否存在收货中的数据
                this.getOrderDeliveryInfo(row.orderCode, "EXECUTE");

                

                //this.getLocationData();

                this.deliveryInShow = true;
            },

                                    /**
             * 收货——弹出框
             */
            deliveryInConsignment() {
                if (!this.checkLists.length) {
                    this.$message({
                        message: "没有选择数据,请先选择需要收货的数据!",
                        type: "warning",
                    });
                    return
                } else if (this.checkLists.length > 0) {
                    if (this.checkLists[0].saleFlag != true) {
                        this.$message({
                            message: "请选择寄售数据!",
                            type: "warning",
                        });
                        return
                    }
                }
                if (this.checkLists.length !== 1) {
                    this.$message({
                        message: "收货数据只能选择一条!",
                        type: "warning",
                    });
                    return
                }
                var row = this.checkLists[0];
                var num = row.orderArriveQuan - row.orderReturnQuan;
                if (num >= row.orderQuan) {
                    this.$message({
                        message: "当前订单收货数量到达，不能再进行收货！",
                        type: "warning",
                    });
                    return;
                }
                this.deliveryInData = {
                    quanCount: row.nowCount,
                    fcCode: row.fcCode,
                    matUnit: row.matUnit,
                    orderCode: row.orderCode,
                    boxCode: "",
                    matCode: row.matCode,
                    matName: row.matName,
                    matQuan: "",
                    newBatchNo: row.orderCode,
                    // oldBatchNo: row.orderCode,
                    oldBatchNo: "",
                    boxHeight: this.whichStorey,
                    matQualityNumber: "", //分装箱数
                    matStandNumber: "",
                    odStockTime: moment().format("YYYY-MM-DD HH:MM:SS"),
                    matProduceTime: moment(new Date).format("YYYY-MM-DD"),
                    whCode: row.whCode,
                    supplier: row.supplier,
                    orderQuan: row.orderQuan,
                    surplusCount: row.orderQuan - row.orderArriveQuan,
                    laCode: "",
                    mtCheck: row.mtCheck,
                    saleFlag: true,
                    printTwo: false
                };

                //查询物料主数据
                this.getMaterialInfo(row.matCode);
                console.log(this.matInfo)

                //查询物料配置信息
                this.getSysMaterialGroup(row.supplier,row.fcCode,row.whCode,row.matCode);

                this.odcCOde = row.orderCode;

                //查看是否存在收货中的数据
                this.getOrderDeliveryInfo(row.orderCode, "EXECUTE");

                

                //this.getLocationData();

                this.orderMesReceiptDialogShow = true;
            },

            /**
             * 根据供应商和工厂编号和通道查询物料信息
             */
            getSysMaterialGroup(supplier,fcCode,whCode,matCode) {
                this.$http
                    .request({
                        url: "/api/sysMaterialGroup/getSysMaterialGroup",
                        method: "GET",
                        params: {
                            vendorCode: supplier,
                            fcCode: fcCode,
                            whCode: whCode,
                            mtCode: matCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            if(resp.data.total != 0){
                                this.checkFlag = resp.data.list[0].checkFlag;    
                            }   
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /**
             * 根据物料类型获取免检库位
             */
            getSysMaterialDeployList(prodCode) {
                this.$http.request({
                    url: "/api/sysMaterialDeploy/getSysMaterialDeployList",
                    method: "GET",
                    showLoading: true,
                    params: {
                        prodCode: prodCode,
                        searchType: "50",
                        fcCode: localStorage.getItem("fcCode") || ""
                    },
                }).then((resp) => {
                    if (resp.status == 100) {
                        this.lcCodeList = resp.data.list || [];
                        this.deliveryInData.laCode = this.lcCodeList[0].laType;
                    }
                }).catch((error) => {});
            },
            /**
             * 获取库位
             */
            getLocationData() {
                this.$http.request({
                    url: "/api/location/getLaCodeAllByType",
                    method: "GET",
                    showLoading: true,
                    params: {
                        lcType: "JY",
                        fcCode: localStorage.getItem("fcCode") || ""
                    },
                }).then((resp) => {
                    if (resp.status == 100) {
                        this.lcCodeList = resp.data.list || [];
                    }
                }).catch((error) => {});
            },

            /**
             * 收货详情——弹出框
             */
            deliveryDetail(row) {
                this.deliveryDetailShow = true;
                this.deliveryDetailSearch.orderCode = row.orderCode;
                // if (row.saleFlag && row.saleFlag== false) {
                    this.deliveryDetailSearch.saleFlag = false
                    this.getOrderDeliveryDetail();
                // } else if (row.saleFlag && row.saleFlag== true) {
                //     this.deliveryDetailSearch.saleFlag = true
                //     this.getOrderDetailByMes()
                // }
            },

            /**
             * 订单详情——收货列表
             */
            getOrderDeliveryDetail() {
                this.$http
                    .request({
                        url: "/api/order/getOrderDeliveryDetail",
                        method: "GET",
                        params: {
                            orderCode: this.deliveryDetailSearch.orderCode || null,
                            odCode: this.deliveryDetailSearch.odCode || null,
                            pageNum: this.deliveryDetailData.pageNum,
                            pageSize: this.deliveryDetailData.pageSize,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.deliveryDetailData.data = resp.data.list || [];
                            this.deliveryDetailData.total = resp.data.total;
                            if (this.deliveryDetailData.total > 0) {
                                for (let e of this.deliveryDetailData.data) {
                                    if(e.matQualityTime == 0){
                                        this.$set(e, "matQualityTime", 12);
                                        var date = new Date(e.matEffectiveTime);
                                        date.setFullYear(date.getFullYear()+1);
                                        this.$set(e, "matEffectiveTime", moment(date).format("YYYY-MM-DD HH:MM:SS"));
                                    }
                                }
                            }
                            if (this.deliveryDetailData.data.length > 0) {
                                for (let i = 0; i < this.deliveryDetailData.data.length; i++) {
                                    if (this.deliveryDetailData.data[i].odStatus == "EXECUTE") {
                                        this.isQuality = true;
                                        break;
                                    } else {
                                        this.isQuality = false;
                                    }
                                }
                            }
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            /**
             * 收货
             */
            insertOrderDelivery() {
                if (this.deliveryInData.matProduceTime == null || this.deliveryInData.matProduceTime == "") {
                    this.$message({
                        message: "生产日期不能为空！",
                        type: "warning",
                    });
                    this.loadingbut = false;
                    this.loadingbuttext = "确定";
                    return;
                }else if (this.deliveryInData.newBatchNo == null || this.deliveryInData.newBatchNo == "") {
                    this.$message({
                        message: "批次号不能为空！",
                        type: "warning",
                    });
                    this.loadingbut = false;
                    this.loadingbuttext = "确定";
                    return;
                }else{
                    const moment = require('moment')
                    this.deliveryInData.matProduceTime = moment(this.deliveryInData.matProduceTime).format("YYYY/MM/DD");
                }
                this.loadingbut = true;
                this.loadingbuttext = "提交中...";
                if (this.deliveryInData.matSpecs != undefined && this.deliveryInData.matSpecs != '') {
                    for (let value of this.deliveryDetailData.data) {
                        if (
                            value.matSpecs == this.deliveryInData.matSpecs &&
                            value.matLenValue == this.deliveryInData.matLenValue
                        ) {
                            this.$message({
                                message: "请勿重复提交",
                                type: "warning",
                            });
                            this.loadingbut = false;
                            this.loadingbuttext = "确定";
                            return;
                        }
                    }

                }

                this.deliveryInData.person = localStorage.getItem("user") || "";
                const reg = /[^\d]/;
                if (this.deliveryInData.matQualityNumber != null) {
                    if (reg.test(this.deliveryInData.matQualityNumber)) {
                        this.$message({
                            message: "分批装箱数输入正整数",
                            type: "warning",
                        });
                        this.loadingbut = false;
                        this.loadingbuttext = "确定";
                        return;
                    }
                }
                // var matNum = this.deliveryInData.matStandNumber * this.deliveryInData.matQualityNumber;
                // if (this.deliveryInData.surplusCount < this.deliveryInData.matQuan || this.deliveryInData.surplusCount < matNum) {
                //     this.$message({
                //         message: "收货数量已超过剩余收货数量！！！",
                //         type: "warning",
                //     });
                //     this.loadingbut = false;
                //     this.loadingbuttext = "确定";
                //     return;
                // }
                if (this.deliveryInData.laCode == '' && this.deliveryInData.mtCheck == '20') {
                    this.$message({
                        message: "请选择收货库位",
                        type: "warning",
                    });
                    this.loadingbut = false;
                    this.loadingbuttext = "确定";
                    return;
                }
                if(this.deliveryInData.matSpecs !=null && this.deliveryInData.matSpecs.length>4){
                    this.$message({
                        message: "规值不能超过4位数！",
                        type: "warning",
                    });
                    this.loadingbut = false;
                    this.loadingbuttext = "确定";
                    return;
                }
                if(this.deliveryInData.oldBatchNo !=null && this.deliveryInData.oldBatchNo.length>10){
                    this.$message({
                        message: "批次号不能超过10位数！",
                        type: "warning",
                    });
                    this.loadingbut = false;
                    this.loadingbuttext = "确定";
                    return;
                }
                 if(this.deliveryInData.steelGrade !=null && this.deliveryInData.steelGrade.length>20){
                    this.$message({
                        message: "钢号不能超过20位数！",
                        type: "warning",
                    });
                    this.loadingbut = false;
                    this.loadingbuttext = "确定";
                    return;
                }
                 if(this.deliveryInData.heatNumber !=null && this.deliveryInData.heatNumber.length>20){
                    this.$message({
                        message: "炉号不能超过20位数！",
                        type: "warning",
                    });
                    this.loadingbut = false;
                    this.loadingbuttext = "确定";
                    return;
                }

                if (this.deliveryInData.matStandNumber != null) {
                    if (reg.test(this.deliveryInData.matStandNumber)) {
                        this.$message({
                            message: "标准箱数输入正整数",
                            type: "warning",
                        });
                        this.loadingbut = false;
                        this.loadingbuttext = "确定";
                        return;
                    }
                }

                if(this.deliveryInData.matQualityNumber !=null && 90 - this.deliveryInData.matQualityNumber < this.deliveryDetailData.data.length){
                    this.$message({
                        message: "一次收货不能超过90箱数！",
                        type: "warning",
                    });
                    this.loadingbut = false;
                    this.loadingbuttext = "确定";
                    return;
                }

                if (this.deliveryDetailData.data.length <= 0) {
                    this.arr = this.deliveryInData;
                } else {
                    for (var value of this.deliveryDetailData.data) {
                        this.deliveryInData.newBatchNo = value.newBatchNo;
                        this.deliveryInData.odCode = value.odCode;
                        this.arr = this.deliveryInData;
                    }
                }
                this.loadingbut = true;
                this.arr.printTwo = this.deliveryInData.printTwo
                this.arr.fcCode = localStorage.getItem("fcCode") || ""
                this.$http
                    .request({
                        url: "/api/order/insertOrderDelivery",
                        method: "POST",
                        showLoading: true,
                        data: this.arr,
                        params: {
                            personNumber: localStorage.getItem("empNumber") || null,
                            matQualityNumber: this.deliveryInData.matQualityNumber || null,
                            matStandNumber: this.deliveryInData.matStandNumber || null
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$message({
                                message: "操作成功",
                                type: "success",
                            });
                            this.logRemarks = "order：订单收货成功";
                            this.deliveryDetailData.data = resp.data;
                            this.deliveryDetailData.printTwo = this.deliveryInData.printTwo;
                            this.$set(this.deliveryInData,"matQuan","");
                            this.$set(this.deliveryInData,"matStandNumber","");
                            this.$set(this.deliveryInData,"matSpecs","");
                            this.$set(this.deliveryInData,"matLenValue","");
                            this.$set(this.deliveryInData,"matQualityNumber","");
                            this.$set(this.deliveryInData,"steelGrade","");
                            this.$set(this.deliveryInData,"heatNumber","");
                            this.$set(this.deliveryInData,"laCode","");
                            this.$set(this.deliveryInData,"boxHeight", this.whichStorey);
                            this.deliveryInData.printTwo = false;
                            this.deliveryInData.matProduceTime =  moment(new Date).format("YYYY-MM-DD");
                        } else {
                            this.$message({
                                message: resp.message,
                                type: "error",
                            });
                            this.logRemarks = "order：订单收货失败";
                        }
                        this.loadingbut = false;
                        this.loadingbuttext = "确定";

                        this.logContent = JSON.stringify(this.deliveryInData);
                        this.systemLog();
                        this.getOrderDeliveryInfo(this.odcCOde, "EXECUTE");

                        //this.orderClose();
                    })
                    .catch((error) => {
                        this.loadingbut = false;
                        this.$message({
                            message: "操作失败",
                            type: "error",
                        });
                    });
            },

            /**
             * 确认收货
             */
            confrimOrderDeliveryConsignment(orderCode) {
                this.confrimOrderDeliverys = true;
                this.$confirm("是否确认收货?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        let info = this.deliveryDetailData.data;
                        let totalScore = info.reduce((pre, cur) => {
                            return pre + cur.matQuan;
                        }, 0);
                        if (this.deliveryInData.quanCount != totalScore) {
                            this.$message({
                                message: "收货总数量输入错误，总数量为" + totalScore,
                                type: "error",
                            });
                            return;
                        }

                        this.$http
                            .request({
                                url: "/api/order/confrimOrderDeliveryConsignment",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    orderCode: orderCode,
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber")
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "确认收货成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "order：订单确认收货成功";
                                    this.orderMesReceiptCLose();
                                   
                                    //调用打印程序
                                    var printList = [];
                                    for (var index in this.deliveryDetailData.data) {
                                        var deliveryData = this.deliveryDetailData.data[index];
                                        var produceTime = moment(deliveryData.matProduceTime).format("YYYYMMDD");

                                        //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度/箱体类型
                                        // var qrCode = "T/" + item.orderCode + "/" + item.boxBarcode + "/" + item.matCode + "/" +
                                        //     item.matQuan + "/" + item.matSpecs + "/" + item.batchNo +
                                        //     "/" + produceTime + "/";

                                        //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                                        // var qrCode = deliveryData.boxCode + "," + this.deliveryInData.orderCode + "," + this.deliveryInData.whCode + "," +
                                        //     deliveryData.matCode + "," + deliveryData.matQuan + "," + deliveryData.matSpecs +
                                        //     "," + deliveryData.newBatchNo + "," + produceTime + "," + deliveryData.boxHeight + ",,,";

                                        //订单号，物料编码，订单项次，供应商代码，通道号，交货数量，批次号，热处理批号，规值，检验方法，箱内数量，运输托盘类型，箱号
                                        var qrCode = this.deliveryInData.orderCode + "," + this.deliveryInData.matCode + "," + this.deliveryInData.lineNo + "," +
                                            this.deliveryInData.supplier + "," + deliveryData.matQuan + "," + deliveryData.matSpecs +
                                            "," + deliveryData.newBatchNo + "," + produceTime + "," + deliveryData.boxHeight + "," +  deliveryData.boxCode + ",,,";

                                        var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                                        var barcodeData = {
                                            boxBarcode: deliveryData.boxCode,
                                            prodCode: deliveryData.matCode,
                                            prodName: deliveryData.matName,
                                            batchNo: deliveryData.newBatchNo,
                                            count: deliveryData.matQuan,
                                            checkPerson: localStorage.getItem("empNumber"),
                                            date: produceTime,
                                            poCode: this.deliveryInData.orderCode,
                                            matSpecs: deliveryData.matSpecs,
                                            whCode: this.deliveryInData.whCode,
                                            boxHeight: deliveryData.boxHeight,
                                            qrCode: qrCode,
                                            supply: this.deliveryInData.supplier,
                                            printTime: printTime,
                                            printTwo: this.deliveryDetailData.printTwo
                                        }
                                        
                                        printList.push(barcodeData);

                                        console.log(printList);
                                        
                                    }

                                    //排序数据对象
                                    // printList.sort((a,b) =>{ 
                                    //     return a.boxBarcode.toLowerCase() > b.boxBarcode.toLowerCase()
                                    // });
                                    // printList.sort((a,b) =>{
                                    //     a.boxBarcode.match(/\d+/)[0] - b.boxBarcode.match(/\d+/)[0];
                                    // });
                                    printList.sort((a,b) =>{
                                        var c = a.boxBarcode.slice(2);
                                        var d = b.boxBarcode.slice(2);
                                        if(c > d){
                                            return 1;
                                        }else if(c < d){
                                            return -1;
                                        }else{
                                            return 0;
                                        }
                                    });
                                    console.log(printList);
                                    this.$printer.printWMSBarcodeList(printList);
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "order：订单确认收货失败";
                                }
                                this.confrimOrderDeliverys = false;
                                this.logContent =
                                    "orderCode：" +
                                    this.deliveryDetailSearch.orderCode +
                                    "\t" +
                                    "person：" +
                                    localStorage.getItem("user");
                                this.deliveryClose();
                            })
                            .catch((error) => {
                                this.confrimOrderDeliverys = false;
                                this.$message({
                                    message: "操作失败",
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.confrimOrderDeliverys = false;
                        this.$message({
                            type: "info",
                            message: "已取消收货",
                        });
                    });
            },

            /**
             * 删除收货记录
             */
            deliveryDetailDel(odId) {
                if (!(odId || this.AllDelete.length)) {
                    this.$message({
                        message: "没有选择数据,请先选择要删除的数据!",
                        type: "error",
                    });
                    return false;
                }
                this.$confirm("正在进行删除收货记录, 是否继续?", "提示", {
                        confirmButtonText: "继续",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        if (odId) {
                            this.$http
                                .request({
                                    url: "/api/order/deleteOrderDelivery",
                                    method: "DELETE",
                                    params: {
                                        // odId: this.AllDelete,
                                        odId: odId,
                                    },
                                })
                                .then((resp) => {
                                    if (resp.status == 100) {
                                        this.$message({
                                            message: "操作成功",
                                            type: "success",
                                        });
                                        this.logRemarks = "order：删除订单收货记录成功";
                                    } else {
                                        this.$message({
                                            message: resp.message,
                                            type: "error",
                                        });
                                        this.logRemarks = "order：删除订单收货记录失败";
                                    }
                                    this.logContent = "odId：" + odId;
                                    this.getOrderDeliveryInfo(this.odcCOde, "EXECUTE");
                                })
                                .catch((error) => {
                                    this.$message({
                                        message: "操作失败",
                                        type: "warning",
                                    });
                                });
                        } else {
                            this.$http
                                .request({
                                    url: "/api/order/deleteOrderDelivery",
                                    method: "DELETE",
                                    params: {
                                        odId: this.AllDelete,
                                    },
                                })
                                .then((resp) => {
                                    if (resp.status == 100) {
                                        this.$message({
                                            message: "操作成功",
                                            type: "success",
                                        });
                                        this.logRemarks = "order：删除订单收货记录成功";
                                    } else {
                                        this.$message({
                                            message: resp.message,
                                            type: "error",
                                        });
                                        this.logRemarks = "order：删除订单收货记录失败";
                                    }
                                    this.logContent = "odId：" + odId;
                                    this.getOrderDeliveryInfo(this.odcCOde, "EXECUTE");
                                })
                                .catch((error) => {
                                    this.$message({
                                        message: "操作失败",
                                        type: "warning",
                                    });
                                });
                        }

                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消提交",
                        });
                    });
            },
            //禁选
            checkboxSelect(row, rowIndex) {
                if (row.sqResult != "WAIT") {
                    return false; // 禁用
                } else {
                    return true; // 不禁用
                }
            },
            /**
             * 多选
             */
            selectAllOrder(val) {
                this.checkLists = val;
            },
            selectAllDel(val) {
                this.checkList = val;
            },
            selectAllDelete(val) {
                this.AllDelete = "";
                var map = val.map((ele) => {
                    return ele.odId;
                })
                this.AllDelete = map.join(",");
            },

             //数量修改-标签打印
            rePrintNumber() {
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请勾选打印单！",
                        type: "warning",
                    });
                    return;
                }
                //无码时添加打印限制
                if (this.lazyNexts) {
                    this.$message.error('请五秒后再打印！')
                    return
                } else {
                    this.checkList.forEach((item) => {

                        var produceTime = moment(item.matProduceTime).format("YYYYMMDD");

                        //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                        // var qrCode = "T/" + item.orderCode + "/" + item.boxBarcode + "/" + item.matCode + "/" +
                        //     item.matQuan + "/" + item.matSpecs + "/" + item.batchNo +
                        //     "/" + produceTime + "/";

                        //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                        var qrCode = item.boxCode + "," + item.orderCode + "," + item.whCode + "," +
                            item.matCode + "," + item.matQuan + "," + item.matSpecs +
                            "," + item.newBatchNo + "," + produceTime + "," + item.boxHeight + ",,,";

                        if (item.matSpecs == undefined) {
                            item.matSpecs = "";
                        }

                        var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                        var barcodeData = {
                            boxBarcode: item.boxCode,
                            prodCode: item.matCode,
                            prodName: item.matName,
                            batchNo: item.newBatchNo,
                            count: item.matQuan,
                            checkPerson: localStorage.getItem("empNumber"),
                            date: produceTime,
                            poCode: item.orderCode,
                            matSpecs: item.matSpecs,
                            whCode: item.whCode,
                            qrCode: qrCode,
                            supply: item.supplier,
                            printTime: printTime
                        }

                        this.$printer.printWMSBarcode(barcodeData);
                    })

                    this.lazyNexts = setTimeout(() => {
                        this.lazyNexts = null
                    }, 5000)
                }
            },


            //关闭弹出框
            orderClose(deliveryInData) {
                this.deliveryInShow = false;
                this.getOrderList();
            },
            deliveryClose() {
                this.deliveryDetailShow = false;
                this.getOrderList();
            },

            //清空
            orderReset() {
                this.orderSearch = {
                     query: {
                        whCode: "",
                        fcCode: localStorage.getItem("fcCode") || "",
                        orderCode: "",
                        supply: "",
                        buyer: "",
                        matCode: "",
                        matName: "",
                        beginTime: "",
                        endTime: "",
                        orderStatus:"EXECUTE"
                    },
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    date: [],
                };
            },
            deliveryReset() {
                this.deliverySearch = {
                    whCode: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    odCode: "",
                    orderCode: "",
                    supply: "",
                    laCode: "",
                    matCode: "",
                    matName: "",
                    person: "",
                    status: "",
                    checkStatus: "WAIT",
                    date: [],
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                };
            },

            //获取物料信息
            getMaterialInfo(prodCode) {
                this.matInfo = {};

                this.$http
                    .request({
                        url: "/api/material/info",
                        method: "GET",
                        params: {
                            prodCode: prodCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.matInfo = resp.data;

                            //根据物料类型查询该物料的免检库位
                            // this.getSysMaterialDeployList(this.matInfo.mtType)

                            if (!this.matInfo) {
                                this.matInfo = {};
                            }

                            if (this.matInfo && this.matInfo.validityMonth >= 60) {
                                this.dematProduceTime = moment().format("YYYY-MM-DD HH:MM:SS");
                            }
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            //查询订单当前收货中的信息
            getOrderDeliveryInfo(odCode, status) {
                this.deliveryDetailData.data = [];
                this.$http
                    .request({
                        url: "/api/order/getOrderDeliveryList",
                        method: "GET",
                        params: {
                            orderCode: odCode || null,
                            status: status || null,
                            pageNum: 0,
                            pageSize: 0,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.deliveryDetailData.data = resp.data.list || [];

                            let num = 0;
                            this.deliveryDetailData.data.forEach((item) => {
                                num += item.matQuan;
                            });
                            for (let e of this.deliveryDetailData.data) {
                                if(e.matQualityTime == 0){
                                    this.$set(e, "matQualityTime", 12);
                                    var date = new Date(e.matEffectiveTime);
                                    date.setFullYear(date.getFullYear()+1);
                                    this.$set(e, "matEffectiveTime", moment(date).format("YYYY-MM-DD HH:MM:SS"));

                                }
                            }
                            this.deliveryInData.quanCount = num;
                        } else {
                            this.$message({
                                message: "操作失败" + resp.message,
                                type: "warning",
                            });
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            /**
             * 获取通道数据
             */
            getWarehouse() {
                this.$http
                    .request({
                        url: "/api/warehouse/getWarehouse",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            whCode: "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.warehouseList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            //获取工厂数据
            getFactoryAll() {
                this.$http
                    .request({
                        url: "/api/factory/getFactoryAll",
                        method: "GET",
                        params: {},
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.factoryList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            /**
             * 修改未质检的收货数量
             */
            updateOrderQuan() {
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "没有选择内容",
                        type: "warning",
                    });
                    return;
                }
                const res = this.checkList.every(e => {
                    if (e.sqResult != "WAIT") {
                        this.$message({
                            message: "请选择未质检的数据",
                            type: "warning",
                        });
                        return false;
                    } else if (e.clicktextss == false) {
                        this.$message({
                            message: "请修改收货数量",
                            type: "warning",
                        });
                        return false;
                    } else if (e.sqResult != "WAIT") {
                        this.$message({
                            message: "请选择待检数据",
                            type: "warning",
                        });
                        return false;
                    } else if (e.matQuan < 0) {
                        this.$message({
                            message: "调整数量不能为负数！",
                            type: "warning",
                        });
                        return false;
                    } else {
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }
                for (let i of this.checkList) {
                    i.matProduceTime = moment(i.matProduceTime).format("YYYY/MM/DD");
                }

                // if (this.checkList.length > 1) {
                //     this.$message({
                //         message: "每次只能处理一箱",
                //         type: "warning",
                //     });
                //     return
                // }

                // if (this.checkList[0].matQuan > 1) {
                //     this.$message({
                //         message: "每次只能处理一箱",
                //         type: "warning",
                //     });
                //     return
                // }

                this.$confirm("是否确认修改数量? ", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/order/updateOrderQuan",
                                method: "POST",
                                showLoading: true,
                                data: this.checkList,
                                params: {
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber")
                                }
                            })
                            .then((res) => {
                                if (res.status == 100) {
                                    this.$message({
                                        message: "提交成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "order：修改数量操作成功";
                                    this.rePrintNumber();
                                } else {
                                    this.$message({
                                        message: res.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "order：修改数量操作失败";
                                }
                                this.logContent = JSON.stringify(this.checkList);
                                this.systemLog();
                                this.getOrderDeliveryList();
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },
            /**
             * 更改数量和规值
             */
            updateBoxQuan(data) {
                if(data.matSpecs !=null && data.matSpecs.length>4){
                    this.$message({
                        message: "规值不能超过4位数！",
                        type: "warning",
                    });
                    return false;
                }
                 if(data.steelGrade !=null && data.steelGrade.length>20){
                    this.$message({
                        message: "钢号不能超过20位数！",
                        type: "warning",
                    });
                    return false;
                }
                 if(data.heatNumber !=null && data.heatNumber.length>20){
                    this.$message({
                        message: "炉号不能超过20位数！",
                        type: "warning",
                    });
                    return false;
                }

                
                this.$set(data, "clicktext", false);
                this.$set(data, "clicktexts", false);
                this.$set(data, "newBach", false);
                this.$set(data, "clicksteelGrade", false);
                this.$set(data, "clickheatNumber", false);
                this.$http
                    .request({
                        url: "/api/order/updateOrderDeliveryQuan",
                        method: "PUT",
                        showLoading: true,
                        params: {
                            odId: data.odId,
                            boxQuan: data.matQuan,
                            matSpecs: data.matSpecs,
                            steelGrade: data.steelGrade,
                            heatNumber: data.heatNumber,
                            newBatchNo: data.newBatchNo,
                            boxHeight: data.boxHeight
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$message({
                                message: "提交成功",
                                type: "success",
                            });
                        } else {
                            this.$message({
                                message: resp.message,
                                type: "error",
                            });
                        }
                        this.getOrderDeliveryInfo(this.odcCOde, "EXECUTE");
                    });
            },

            //全选
            selectAllPrint(val) {
                this.selectAllPrintList = val;
            },

            //标签打印
            rePrintBarcode() {
                if (this.selectAllPrintList.length == 0) {
                    this.$message({
                        message: "请勾选打印单！",
                        type: "warning",
                    });
                    return;
                }
                //无码时添加打印限制
                if (this.lazyNext) {
                    this.$message.error('请五秒后再打印！')
                    return
                } else {
                    this.selectAllPrintList.forEach((item) => {

                        console.log(item)

                        let od = this.orderSearch.data.find(o => o.orderCode == item.orderCode);
                        var produceTime = moment(item.matProduceTime).format("YYYYMMDD");

                        //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                        // var qrCode = "T/" + item.orderCode + "/" + item.boxBarcode + "/" + item.matCode + "/" +
                        //     item.matQuan + "/" + item.matSpecs + "/" + item.batchNo +
                        //     "/" + produceTime + "/";

                        //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                        var qrCode = item.boxCode + "," + item.orderCode + "," + od.whCode + "," +
                            item.matCode + "," + item.matQuan + "," + item.matSpecs +
                            "," + item.newBatchNo + "," + produceTime + "," + item.boxHeight + ",,,";

                        if (item.matSpecs == undefined) {
                            item.matSpecs = "";
                        }

                        var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                        var barcodeData = {
                            boxBarcode: item.boxCode,
                            prodCode: item.matCode,
                            prodName: item.matName,
                            batchNo: item.newBatchNo,
                            count: item.matQuan,
                            checkPerson: localStorage.getItem("empNumber"),
                            date: produceTime,
                            poCode: item.orderCode,
                            matSpecs: item.matSpecs,
                            whCode: od.whCode,
                            qrCode: qrCode,
                            supply: od.supplier,
                            printTime: printTime
                        }

                        this.$printer.printWMSBarcode(barcodeData);
                    })

                    this.lazyNext = setTimeout(() => {
                        this.lazyNext = null
                    }, 5000)
                }
            },
            downLoadFileDelivery() {
                this.downloadLoadingDelivery = true;
                var paramsObj = {
                    fcCode: this.deliverySearch.fcCode || null,
                    orderCode: this.deliverySearch.orderCode || null,
                    odCode: this.deliverySearch.odCode || null,
                    supply: this.deliverySearch.supply || null,
                    laCode: this.deliverySearch.laCode || null,
                    matCode: this.deliverySearch.matCode || null,
                    matName: this.deliverySearch.matName || null,
                    person: this.deliverySearch.person || null,
                    //status: this.deliverySearch.status || null,
                    whCode: this.deliverySearch.whCode || null,
                    beginTime: this.deliverySearch.date ? this.deliverySearch.date[0] : null,
                    endTime: this.deliverySearch.date ? this.deliverySearch.date[1] : null,
                    checkStatus: this.deliverySearch.checkStatus || null,
                    pageNum: 1,
                    pageSize: 999999,
                }
                this.$http.request({
                    url: '/api/order/getOrderDeliveryList',
                    method: 'GET',
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoadDelivery(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoadDelivery(list) {
                list.forEach(function(c) {
                    if (c.odStatus == 'EXECUTE') {
                        c['odStatus'] = '收货中'
                    } else if (c.odStatus == 'WAITCHECK') {
                        c['odStatus'] = '待检'
                    } else if (c.odStatus == 'CHECKING') {
                        c['odStatus'] = '检验中'
                    } else if (c.odStatus == 'WAIT') {
                        c['odStatus'] = '待入库'
                    } else if (c.odStatus == 'INPUT') {
                        c['odStatus'] = '已入库'
                    } else if (c.odStatus == 'WAITRETURN') {
                        c['odStatus'] = '待退货'
                    } else if (c.odStatus == 'RETURNED') {
                        c['odStatus'] = '已退货'
                    }

                    if (c.sqResult == 'OK') {
                        c['sqResult'] = '合格'
                    } else if (c.sqResult == 'NOK') {
                        c['sqResult'] = '不合格'
                    } else if (c.sqResult == 'PICK') {
                        c['sqResult'] = '挑选'
                    } else if (c.sqResult == 'WAIT') {
                        c['sqResult'] = '待检'
                    } else if (c.sqResult == 'COMPLETE') {
                        c['sqResult'] = '挑选完成'
                    } else if (c.sqResult == 'CLOSE') {
												c['sqResult'] = '关闭'
										} else {
                        c['sqResult'] = '免检'
                    }

                    if (c.matQualityTime == 0) {
                        c['matQualityTime'] = '12'
                        var date = new Date(c.matEffectiveTime);
                        date.setFullYear(date.getFullYear()+1);
                        c['matEffectiveTime'] = moment(date).format("YYYY-MM-DD HH:MM:SS")
                    }

                    if (c.submitCheckFlag == false) {
                        c['submitCheckFlag'] = '否'
                    } else if (c.submitCheckFlag == true) {
                        c['submitCheckFlag'] = '是'
                    } else{
                        c['submitCheckFlag'] = '否'
                    }
                })
                import('@/libs/Export2Excel').then(excel => {
                    const tHeader = ['通道编号', '单据号','收货单号', '物料编号', '物料描述', '收货数量', '调整收货数量', '原始批次号', '新批次号',  '收货库位', '包装箱号',  '物料属性',
                       '质检状态', '合格数量', '不合格数量', '规值', '钢号', '炉号', '采购入库时间',
                        '生产日期', '保质期', '有效期', '创建时间', '要求到货时间', '收货人', '是否提交质检给数字化工厂', '供货商'
                    ]
                    const filterVal = ['whCode', 'orderCode', 'odCode', 'matCode', 'matName',  'matQuan', 'matQuan', 'oldBatchNo','newBatchNo', 'laCode', 'boxCode','matType', 
                          'sqResult', 'goodNumber', 'badNumber', 'matSpecs', 'steelGrade', 'heatNumber', 'odStockTime',
                        'matProduceTime', 'matQualityTime', 'matEffectiveTime', 'createTime', 'requireTime', 'person', 'submitCheckFlag', 'supplier'
                    ]
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '来料收货'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "order_delivery：导出来料收货订单"
                    this.systemLog();
                    this.downloadLoadingDelivery = false
                })
            },
            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    whCode: this.orderSearch.query.whCode || null,
                    fcCode: this.orderSearch.query.fcCode || null,
                    orderCode: this.orderSearch.query.orderCode || null,
                    supply: this.orderSearch.query.supply || null,
                    buyer: this.orderSearch.query.buyer || null,
                    matCode: this.orderSearch.query.matCode || null,
                    matName: this.orderSearch.query.matName || null,
                    orderStatus: this.orderSearch.query.orderStatus || null,
                    beginTime: this.orderSearch.query.beginTime || null,
                    endTime: this.orderSearch.query.endTime || null,
                    wareType:'10',
                    pageNum: 1,
                    pageSize: 999999,
                }
                this.$http.request({
                    url: '/api/order/getOrderList',
                    method: 'GET',
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.orderStatus == 'EXECUTE') {
                            c['orderStatus'] = '进行中'
                        }else if (c.orderStatus == 'COMPLETE') {
                            c['orderStatus'] = '完成'
                        }

                        if (c.overdueDay > 0) {
                            c['overdueDay'] = '延期' + c.overdueDay
                        } else if (c.overdueDay < 0) {
							let days = -c.overdueDay;
                            c['overdueDay'] = '提前' + days
                        } else if (c.overdueDay == 0) {
                            c['overdueDay'] = ''
                        }

                        if (c.digitFlag == false) {
                            c['digitFlag'] = '否'
                        } else if (c.digitFlag == true) {
                            c['digitFlag'] = '是'
                        }
                    })
                    const tHeader = ['通道编号', '单据号', '物料编号', '物料描述',  '订单数量', '已收数量',
                        '退货数量', '未收数量', '当前收货数量',  '要求到货时间', '实际到货时间', '超期天数', '是否提交质检', '供应商', '采购员'
                    ]
                    const filterVal = ['whCode', 'orderCode', 'matCode', 'matName',  'orderQuan', 'orderArriveQuan',
                        'orderReturnQuan', 'notReceivedNumber', 'nowCount', 'requireTime', 'orderRealTime', 'overdueDay', 'digitFlag', 'supplier', 'buyerName'
                    ]
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '订单详情'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "order_purchase：导出订单详情"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "来料收货",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        showLoading: true,
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
            /**
             * 寄售收货——弹出框
             */
            orderMesReceiptOpen() {
                if (!this.checkLists.length) {
                    this.$message({
                        message: "没有选择数据,请先选择需要收货的数据!",
                        type: "warning",
                    });
                    return
                } else if (this.checkLists.length > 0) {
                    if (this.checkLists[0].saleFlag != true) {
                        this.$message({
                            message: "请选择寄售数据!",
                            type: "warning",
                        });
                        return
                    }
                }
                if (this.checkLists.length !== 1) {
                    let firstOrder = this.checkLists[0].orderCode
                    for(var index in this.checkLists){
                        if (firstOrder === this.checkLists[index].orderCode) {
                            continue
                        } else {
                            this.$message({
                                message: "不同单据号的数据只能选择一条!",
                                type: "warning",
                            });
                            return
                        }
                    }
                }
                this.orderMesReceiptDialogShow = true
                this.orderMesReceiptSearchInfo.fcCode = localStorage.getItem("fcCode") || ""
                // this.orderMesReceiptSearchInfo.whCode = localStorage.getItem("whCode") || ""
                this.orderMesReceiptSearchInfo.orderCode = this.checkLists[0].orderCode || ""
                this.orderMesReceiptSearchInfo.saleFlag = true //寄售
                if (this.checkLists.length === 1) {
                    this.orderMesReceiptSearchInfo.matCode = this.checkLists[0].matCode || ""
                    this.orderMesReceiptSearchInfo.supplierCode = this.checkLists[0].supplierCode || ""
                } else {
                    this.getOrderMesReceiptDetails()
                }

                this.getSysMaterialGroupVOList()
            },
            orderMesReceiptCLose() {
                this.orderMesReceiptDialogShow = false;
                this.orderMesReceiptSearchInfo = {
                    fcCode: localStorage.getItem("fcCode") || "",
                    whCode: localStorage.getItem("whCode") || "",
                    orderCode: '',
                    matCode: '',
                    supplierCode: '',
                    saleFlag: true, //寄售
                    materialGroupList: [],
                }
                this. orderMesReceiptDetail.data = []
                this. orderMesReceiptDetail.pageNum = 1
                this. orderMesReceiptDetail.pageSize = 50
                this. orderMesReceiptDetail.total = 0
                this. orderMesReceiptDetail.selectList = []

                this.getOrderList();
            },
            /**
             * 根据供应商和工厂编号和通道查询物料信息
             */
            getSysMaterialGroupVOList() {
                this.$http
                    .request({
                        url: "/api/sysMaterialGroup/getSysMaterialGroupVOList",
                        method: "GET",
                        params: {
                            fcCode: this.orderMesReceiptSearchInfo.fcCode || null,
                            // whCode: this.orderMesReceiptSearchInfo.whCode || null,
                            saleFlag: this.orderMesReceiptSearchInfo.saleFlag || null
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.orderMesReceiptSearchInfo.materialGroupList = resp.data || [];

                            if (this.orderMesReceiptSearchInfo.matCode) {
                                let row = this.orderMesReceiptSearchInfo.materialGroupList.find((item) => item.matCode = this.orderMesReceiptSearchInfo.matCode);
                                this.changeMaterialGroup(row)
                            }
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            changeMaterialGroup(row) {
                this.orderMesReceiptSearchInfo.materialGroupVendorList = row.vendorList;
                this.orderMesReceiptSearchInfo.supplierCode = row.vendorList ? row.vendorList[0].vendorCode : "";
                this.getOrderMesReceiptDetails();
            },
            /**
             * 获取送货单详情
             */
            getOrderMesReceiptDetails() {
                // if (!this.orderMesReceiptSearchInfo.whCode) {
                //     this.$message({
                //         type:"waring",
                //         message:"通道不能为空"
                //     })
                //     return
                // }
                // if (!this.orderMesReceiptSearchInfo.matCode) {
                //     this.$message({
                //         type:"waring",
                //         message:"物料编号不能为空"
                //     })
                //     return
                // }
                // if (!this.orderMesReceiptSearchInfo.supplierCode) {
                //     this.$message({
                //         type:"waring",
                //         message:"供应商不能为空"
                //     })
                //     return
                // }
                this.orderMesReceiptLoading = true
                this.$http
                    .request({
                        url: "/api/orderMesReceipt/getOrderMesReceiptDetails",
                        method: "GET",
                        params: {
                            pageNum: this.orderMesReceiptDetail.pageNum,
                            pageSize: this.orderMesReceiptDetail.pageSize,
                            fcCode: this.orderMesReceiptSearchInfo.fcCode || null,
                            // whCode: this.orderMesReceiptSearchInfo.whCode || null,
                            orderCode: this.orderMesReceiptSearchInfo.orderCode || null,
                            matCode: this.orderMesReceiptSearchInfo.matCode || null,
                            supplierCode: this.orderMesReceiptSearchInfo.supplierCode || null
                        },
                    })
                    .then((resp) => {
                        this.orderMesReceiptLoading = false
                        if (resp.status == 100) {
                            this.orderMesReceiptDetail.data = resp.data.list || []
                            this.orderMesReceiptDetail.total = resp.data.total
                        }
                    })
                    .catch((error) => {
                        this.orderMesReceiptLoading = false
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            selectOrderMesReceipt(val) {
                this.orderMesReceiptDetail.selectList = val || []
            },
            /**
             * 确认收货
             */
            orderMesReceiptConfirm() {
                if (this.orderMesReceiptDetail.selectList.length === 0) {
                    this.$message({
                        message: "请选择箱数据",
                        type: "warning",
                    });
                    return
                }
                this.$confirm("是否确认收货?", "提示", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    console.log("收货");
                    this.$http
                        .request({
                            url: "/api/orderMesReceipt/updateOrderMesReceiptDetail",
                            method: "POST",
                            params: {
                                person: localStorage.getItem("user"),
                                personNumber: localStorage.getItem("empNumber")
                            },
                            data: this.orderMesReceiptDetail.selectList
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.logContent = "收货成功, person: " + localStorage.getItem("user") + ", personNumber: " + localStorage.getItem("empNumber")
                                this.$message({
                                    message: "收货成功",
                                    type: "success",
                                });
                                this.orderMesReceiptCLose();
                            } else {
                                this.logContent = "收货失败, person: " + localStorage.getItem("user") + ", personNumber: " + localStorage.getItem("empNumber")
                                this.$message({
                                    message: resp.message,
                                    type: "error",
                                });
                            }
                            this.logRemarks = "order_mes：寄售收货"
                            this.systemLog();
                        })
                        .catch((error) => {
                            this.$message({
                                message: "操作失败",
                                type: "warning",
                            });
                        });
                })
                .catch((error) => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
            },

            getOrderDetailByMes() {
                this.$http
                    .request({
                        url: "/api/orderMesReceipt/getOrderMesReceiptDetails",
                        method: "GET",
                        params: {
                            pageNum: this.deliveryDetailData.pageNum,
                            pageSize: this.deliveryDetailData.pageSize,
                            orderCode: this.deliveryDetailSearch.orderCode || null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.deliveryDetailData.data = resp.data.list || []
                            this.deliveryDetailData.total = resp.data.total
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
        },
        activated(){
            this.getWarehouse();
            this.getFactoryAll();
            /* 获取首页的数据 */
            this.getOrderList();
        },
    }
</script>

<style lang="scss">
    .but {
        float: right;
        // margin-top: 5%;
        // margin-bottom: 1%;
    }

    .harvestRecord {
        min-height: 10% !important;
        max-height: 10% !important;
        ;

        .el-table-wrapper {
            .el-table {
                height: 100% !important;
            }
        }
    }

    .Receivingtake-box {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .Receivingtake {
        width: 50%;
        padding: 5px 0;
        text-align: center;
        display: inline-block;
        cursor: pointer;
    }

    .imageObj {
        width: 20px !important;
        height: 20px !important;
        cursor: pointer;
    }
</style>